<template>
  <div class="tab-content-two__container">
    
    <!-- head -->
    <div class="content__head">
      <h2 class="content__head-title">{{ onlineMaintenance.title }}</h2>
      <p class="content__head-text" v-html="onlineMaintenance.content"></p>
    </div>

    <!-- body -->
    <div class="content__body">
      <!-- img01 -->
      <div class="content__body__img-one-box flex f-jus-center">
        <div class="content__body__img-one">
          <img src="../../../../assets/images1/customer_service/khfw11.jpg" alt="">
        </div>
      </div>

      <!-- img02 -->
      <div class="content__body__img-two">
        <!-- <img src="../../../../assets/images1/customer_service/online_maintenance.jpg" alt=""> -->
      </div>

      <div class="content__body__service-box flex">
        <!-- left img -->
        <div class="content__body__service-box__item content__body__service-box__left flex f-jus-end">
          <div class="content__body__service-box__left-bg"></div>
        </div>
        <!-- right text -->
        <div class="content__body__service-box__item content__body__service-box__right">
          <!-- title -->
          <h2 class="content__body__service-box__right-title">{{ onlineMaintenance.group1.title }}</h2>
          <div v-for="(txt, i) in onlineMaintenance.group1.list" :key="i" class="content__body__service-box__right-txt flex">
            <span style="padding-right:4px;">●</span>
            <span>{{ txt }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 联系我们 -->
    <div class="content__contact-us flex f-center">
      <div class="content__contact-us__box flex f-column f-center">
        <div class="content__contact-us__title">
          <span>{{ onlineMaintenance.group2.title }}</span>
        </div>
        <p class="content__contact-us__desc">
          <span>{{ onlineMaintenance.group2.content }}</span>
        </p>
        <div class="content__contact-us__btn" @click="toCallMe">
          <span>{{ onlineMaintenance.group2.button_text }}</span>
        </div>
      </div>
    </div>


    <!-- 获益列表 -->
    <div class="content__rights-list flex f-column f-center">
      <h3 class="content__rights-item__title">
        <span style="padding-right:2px;">●</span>
        <span>{{ onlineMaintenance.rights_list_title }}</span>
      </h3>
      <ul class="flex f-jus-center">
        <li
        class="content__rights-item"
        v-for="(rights, i) in onlineMaintenance.rights_list"
        :key="i">
          <p class="content__rights-item__txt">{{ rights }}</p>
        </li>
      </ul>
    </div>
    <footer-wrap></footer-wrap>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'


export default {
    name: 'TabContentTwo',

    data() {
        return {
          
        }
    },

    computed: {
      ...mapGetters([
        'currentLang'
      ]),
      onlineMaintenance() {
        return this.currentLang.config.customerServicePage.onlineMaintenance
      },
    },


    created() {

    },

    methods: {
      toCallMe(){
        this.$router.push('/callMe')
      }
    }
}
</script>

<style scoped lang="scss">

p, div, span {
  margin: 0;
  padding: 0;
}

.content__head {
  width: 1000px;
  height: auto;
  margin: 50px auto;
  text-align: center;

  h2 {
    color: #323232;
    font-weight: normal;
    margin-bottom: 30px;
    font-size: 30px;
  }

  p {
    color: #777777;
  }

  .content__head-text {
    line-height: 1.8;
    font-size: 18px;
    color: #777;
    text-align: justify;
    text-align-last: center;
  }
}


.content__body {

  .content__body__img-one-box {
    // height: 550px;
    margin-bottom: 40px;
  }

  .content__body__img-one {
    margin-top: 16px;
    width: 1000px;
    // height: 460px;
    // background: url("../../../../assets/images1/customer_service/online_maintenance.jpg") no-repeat scroll;
    // background: url("../../../../assets/images1/customer_service/khfw11.jpg") no-repeat scroll;
    background-position: center center;
    background-size: cover;
  }

  .content__body__img-one img {
    width: 100%;
    height: auto;
  }

  .content__body__img-two {
    height: 450px;
    // background: url("../../../../assets/images1/customer_service/khfw12.jpg") no-repeat scroll;
    background: url("../../../../assets/images1/customer_service/khfw12.png") no-repeat scroll;
    background-position: center center;
    background-size: cover;
  }

  .content__body__img-two img {
    width: 100%;
    height: 100%;
  }

  .content__body__service-box {
    background: #fff;
  }

  .content__body__service-box__item {
    padding: 0 90px;
    width: 50%;
    height: 470px;
    min-height: 470px;
    line-height: 2;
  }

  .content__body__service-box__left-bg {
    margin-top: 80px;
    width: 350px;
    height: 250px;
    background: url("../../../../assets/images1/customer_service/khfw09.png") no-repeat scroll;
    background-position: center center;
    background-size: cover;
  }

  .content__body__service-box__right-title {
    margin: 120px 0 40px;
    font-weight: 500;
    letter-spacing: 1px;
    color: #0F335E;
  }

  .content__body__service-box__right-txt {
    margin-top: 12px;
    color: #777;
    line-height: 1.5;
    font-size: 18px;
  }
}


.content__contact-us {
  height: 550px;
  width: 100%;
  background: url("../../../../assets/images1/customer_service/khfw13.jpg") no-repeat scroll;
  background-position: center center;
  background-size: cover;

  .content__contact-us__box {
    width: 1186px;
    height: 276px;
    background-color: #fff;
  }

  .content__contact-us__title {
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 2px;
  }

  .content__contact-us__desc {
    margin: 30px 0 28px;
    color: #777;
  }
  
  .content__contact-us__btn {
    width: 130px;
    height: 50px;
    background-color: #e8363e;
    color: #fff;
    text-align: center;
    line-height: 50px;
  }
  .content__contact-us__btn:hover {
    cursor: pointer;
  }
}


.content__rights-list {
  width: 100%;
  height: 310px;

  .content__rights-item {
    width: 200px;
    margin-right: 30px;
  }
  .content__rights-item:last-child {
    margin-right: 0;
  }

  .content__rights-item__title {
    margin-bottom: 20px;
    font-size: 22px;
    font-weight: 500;
    letter-spacing: 1px;
    color: #0F335E;
  }

  .content__rights-item__txt {
    color: #777;
    line-height: 1.6;
    text-align: justify;
    font-size: 18px;
  }
}

</style>


// WEBPACK FOOTER //
// src/pages/home/home_customer_service/components/TabContentTwo.vue